import { IEnrollmentData } from '@contexts/EnrollmentContext'
import { XStack, Text } from 'tamagui'
import { useTranslation } from 'react-i18next'
interface IContentProgressProps {
  enrollment: IEnrollmentData
}

export function ContentProgress({ enrollment }: IContentProgressProps) {
  const { t } = useTranslation('CourseDetails')
  return (
    <XStack gap="$spacing-inset-quarck">
      <Text
        color="$progress-complete"
        fontSize="$font-size-xxxs"
        fontFamily="$mulishBold"
        fontWeight="700"
      >
        {Math.round(enrollment?.progressCard?.progress || 0)}%
      </Text>
      <Text
        color="$text-primary"
        fontSize="$font-size-xxxs"
        fontFamily="$mulishBold"
        fontWeight="700"
      >
        |
      </Text>
      <Text
        color="$progress-complete"
        fontSize="$font-size-xxxs"
        fontFamily="$mulishBold"
        fontWeight="700"
      >
        {enrollment?.progressCard?.completed}
      </Text>
      <Text
        color="$text-primary"
        fontSize="$font-size-xxxs"
        fontFamily="$mulishRegular"
      >
        {t('de')} {enrollment?.progressCard?.total} {t('conteúdos')}
      </Text>
    </XStack>
  )
}
